<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
export default { name: 'App' }
</script>
<style>
* { margin: 0; padding: 0; box-sizing: border-box; }
html, body, #app { height: 100%; }
body { font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Microsoft YaHei', 'Helvetica Neue', sans-serif; color: #333; line-height: 1.6; background: #fff; }
a { text-decoration: none; color: inherit; }
.container { max-width: 1500px; margin: 0 auto; padding: 0 20px; }
</style>
